
import * as THREE from "../../../../libs/three.js/build/three.module.js";
import {ctrlPolygon} from './ctrlPolygon.js'
import {LineDraw } from "../../utils/DrawUtil.js";
import Sprite from '../../objects/Sprite.js'
import {config} from '../../settings.js'
 
import math from "../../utils/math.js";
let texLoader = new THREE.TextureLoader() 

let color = new THREE.Color(config.clip.color)

let markerMats
let markerSizeInfo = {width2d: 40}


const pickOrders = {
    marker:1,
    area: 0,
}

export class mapClipBox extends ctrlPolygon {
    constructor (center, scale) { 
        center = center.clone().setZ(0);//所有Z都为0
        
        
        let prop = {
            points : getPoints(center, scale, 0),
            closed : true,
            atPlane: true,
            isRect : true,
            dimension : '2d'
        }
         
        
        super('mapClipBox', prop)
        
        this.angle = 0
        this.createRotateBar();
        this.edgeMarkers = [];
        
        //addMarkers:
        this.initData(prop)
        
        
        
        
        {//areaPlane event 能拖动 
            this.areaPlane.addEventListener('mouseover',()=>{ 
                viewer.dispatchEvent({
                    type : "CursorChange", action : "add",  name:"mapClipMove"
                })  
            })
            this.areaPlane.addEventListener('mouseleave',()=>{ 
                viewer.dispatchEvent({
                    type : "CursorChange", action : "remove",  name:"mapClipMove"
                })
            })
            
            let lastPos;
            let drag = (e)=>{
                let intersect = e.intersect.orthoIntersect 
                if(lastPos){ 
                    let moveVec = new THREE.Vector3().subVectors(intersect, lastPos).setZ(0)
                    this.center.add(moveVec)
                    this.updatePoints()
                    this.dispatchEvent({type:'repos'})
                     
                } 
                lastPos = intersect.clone();                
            }
            let drop = (e)=>{
                lastPos = null
            }
            this.areaPlane.addEventListener('drag', drag)
            this.areaPlane.addEventListener('drop', drop)
              
        }
        
        
        /* this.addEventListener('dragChange',()=>{
            this.updateTwoMidMarker(index+1)
        }) */
        
        
        
        Potree.Utils.setObjectLayers(this, 'mapObjects' )
    }
   
   
    
    
    
    getScale(){
        return new THREE.Vector3(this.points[0].distanceTo(this.points[1]), this.points[1].distanceTo(this.points[2]) ,1)
    }
 
   
    
    addMarker(o={} ){
        let marker = new Sprite({mat:this.getMarkerMaterial('default'), pickOrder:pickOrders.marker, sizeInfo: markerSizeInfo, dontFixOrient: true, viewports:viewer.mapViewer.viewports, name:"mapClipBox_marker",   } )
        
        marker.renderOrder = 3 
        //marker.markerSelectStates = {}
        
        let edge = LineDraw.createLine([new THREE.Vector3,new THREE.Vector3],{color  })
        let edgeMarker = new Sprite({mat:this.getMarkerMaterial('default'),  pickOrder:pickOrders.marker, sizeInfo: markerSizeInfo, dontFixOrient: true, viewports:viewer.mapViewer.viewports, name:"mapClipBox_edgePoint"} )
        let mouseover = (e) => {
            this.setMarkerSelected(e.object, true, 'single');
            viewer.dispatchEvent({
                type : "CursorChange", action : "add",  name:"markerMove"
            }) 
        };
        let mouseleave = (e) => {
            this.setMarkerSelected(e.object, false, 'single'); 
            viewer.dispatchEvent({
                type : "CursorChange", action : "remove",  name:"markerMove"
            })
        }
        edgeMarker.addEventListener('mouseover', mouseover);
        edgeMarker.addEventListener('mouseleave', mouseleave);
        let dragInfo = {lastPos:null};
        edgeMarker.addEventListener('drag', this.dragEdge.bind(this,dragInfo));
        edgeMarker.addEventListener('drop', this.dropEdge.bind(this,dragInfo));   
        this.edgeMarkers.push(edgeMarker)
        this.add(edgeMarker)
        marker.dispatchEvent('addHoverEvent')  
      
        super.addMarker({point:o.point, marker:marker,  edge})
        
    }
    
    
    
    dragEdge(dragInfo, e){//拖拽一个边（或一个边类型的marker），带动它的两个端点。 可以转化为拖拽marker往法线方向
        var I, atMap 
         
        atMap = e.dragViewport.name == 'mapViewport'
        I = e.intersect.orthoIntersect 
        
        if (I && dragInfo.lastPos) {
            let i = this.edgeMarkers.indexOf(e.drag.object);
            if (i !== -1) {  
                let lineNormal = math.getNormal2d({p1:this.points[i], p2:this.points[(i+1)%4]}); 
                let moveVec = new THREE.Vector3().subVectors(I, dragInfo.lastPos).setZ(0)//移动的向量
                let dragVec = moveVec.projectOnVector(lineNormal).setZ(0)//在法线上移动的向量
                let newPos = new THREE.Vector3().addVectors(this.points[i], dragVec) //marker应到的位置
                this.dragChange(newPos, i, atMap) //转化为这个marker的拖拽
            }
        }
        dragInfo.lastPos = I.clone();  
    }
    dropEdge(dragInfo, e){
        dragInfo.lastPos = null 
        this.setMarkerSelected(e.drag.object, false, 'single') //拖拽时似乎没有触发mouseout
    }
    
    
    
    createAreaPlane(){
        var planeMat =  new THREE.MeshBasicMaterial({
            color,//"#00eeff",
            side:THREE.DoubleSide,
            opacity:0.3,
            transparent:true,
            depthTest:false
        })
        
        return super.createAreaPlane(planeMat)
    }
    
    
    
    getMarkerMaterial(type) {
        if(!markerMats){
            markerMats = {  
                default:    new THREE.MeshBasicMaterial({  
                    transparent: !0,
                    color,
                    opacity: 0.8,
                    map: texLoader.load(Potree.resourcePath+'/textures/whiteCircle.png' ),  
                }),
                select:    new THREE.MeshBasicMaterial({   
                    transparent: !0,
                    color,
                    opacity: 1,
                    map: texLoader.load(Potree.resourcePath+'/textures/whiteCircle.png' ), 
                     
                }),   
            }
            mapClipBox.markerMats = markerMats
        }
        return markerMats[type]
        
    }
    
    setMarkerSelected(marker, state, hoverObject){ 
        //console.warn(marker.id , state, hoverObject)
        if(state == 'hover'){
            marker.material = this.getMarkerMaterial('select')
        }else{
            marker.material = this.getMarkerMaterial('default')
        }
        
        /* marker.markerSelectStates[hoverObject] = state
        let absoluteState = false
        for(var i in marker.markerSelectStates){
            if(marker.markerSelectStates[i]){
                absoluteState = true; break;
            }
        }
        if(absoluteState){
            marker.material = this.getMarkerMaterial('select')
        }else{
            marker.material = this.getMarkerMaterial('default')
        }
        
        marker.selected = absoluteState */
        
        viewer.mapViewer.dispatchEvent('content_changed') 
    }
    
    createRotateBar(){
        //中心点在线的一端，整体初始在box上方
        const lineLen = 1.5, circleWidth = 2, barOpacity = 0.7;
       
        let object = new THREE.Object3D;
        
        let bar = new Sprite({mat:new THREE.MeshBasicMaterial({ 
                side:THREE.DoubleSide,
                opacity: barOpacity,
                transparent:true,
                depthTest:false, 
                map: texLoader.load(Potree.resourcePath+'/textures/rotation_circle.png' ), 
            }) ,
            root:object,
            sizeInfo: markerSizeInfo, 
            dontFixOrient: true,
            viewports:viewer.mapViewer.viewports,
            name:"mapClipRotateBar"
        })
        bar.position.set(0,lineLen+circleWidth/2,0)
        bar.scale.set(circleWidth,circleWidth,circleWidth)
        
        bar.addEventListener('mouseover',()=>{
            bar.material.opacity = 1
            viewer.dispatchEvent({
                type : "CursorChange", action : "add",  name:"mapClipRotate"
            })
            viewer.mapViewer.dispatchEvent('content_changed') 
        })
        
        let leave = ()=>{ 
            bar.material.opacity = barOpacity
            viewer.dispatchEvent({
                type : "CursorChange", action : "remove",  name:"mapClipRotate"
            })
            viewer.mapViewer.dispatchEvent('content_changed') 
            
        } 
        bar.addEventListener('mouseleave',leave)
        this.addEventListener('dispose', leave)    
        
        let lastPos;
        bar.addEventListener('drag',(e)=>{
            var intersect = e.intersect.orthoIntersect   
            if(lastPos){ 
                let vec1 = new THREE.Vector3().subVectors(lastPos, this.center).setZ(0)
                let vec2 = new THREE.Vector3().subVectors(intersect, this.center).setZ(0)
                let angle = math.getAngle(vec1,vec2,'z')  
                this.angle += angle 
                this.rotateBar.rotation.z = this.angle
                this.updatePoints() 
                this.dispatchEvent({type:'rotate', angle: this.angle})
            }
            lastPos = intersect.clone();       
        })
        bar.addEventListener('drop',()=>{
            lastPos = null 
            viewer.dispatchEvent({
                type : "CursorChange", action : "remove",  name:"mapClipRotate"
            })
        })
        
        let line = LineDraw.createLine([new THREE.Vector3, new THREE.Vector3(0,lineLen,0)],{color})
        
        
        object.add(bar)
        object.add(line) 
        this.add(object)
        this.rotateBar = object
        this.rotateBar.bar = bar
    }
    
    updatePoints(scale){
        this.points = getPoints(this.center, scale || this.getScale(), this.angle)
        this.getPoint2dInfo(this.points)
        this.update({ifUpdateMarkers:true}) 
    }
    
    update(options={}){ 
        super.update(options)
        
        {//update rotateBar
            let center = new THREE.Vector3().addVectors(this.points[0], this.points[1]).multiplyScalar(0.5); 
            this.rotateBar.position.copy(center) 
            this.rotateBar.bar.waitUpdate()//更新sprite matrix
        }
        {
            for(let i=0;i<4;i++){
                let current = this.points[i];
                let next = this.points[(i+1)%4];
                let mid = new THREE.Vector3().addVectors(current, next).multiplyScalar(0.5)
                
                this.updateMarker(this.edgeMarkers[i], mid)
            }
            
            
        }
        
        
    }
    
    dispose(){
        super.dispose()
        this.dispatchEvent('dispose')
        this.rotateBar.bar.dispose()
        
    }
     
}






function getPoints(center, scale, angle=0){  
    let points = [
        new THREE.Vector3(-scale.x/2, +scale.y/2, 0),  
        new THREE.Vector3(+scale.x/2, +scale.y/2, 0), 
        new THREE.Vector3(+scale.x/2, -scale.y/2, 0),  
        new THREE.Vector3(-scale.x/2, -scale.y/2, 0),     
    ] 
    var rotMatrix = new THREE.Matrix4().makeRotationAxis(new THREE.Vector3(0,0,1), angle)//再旋转 
    points.forEach(e=>{
        e.applyMatrix4(rotMatrix) 
        e.add(center) 
    })
    return points
}
 